// extracted by mini-css-extract-plugin
module.exports = {"link":"BackToTopButton_link__cL99o","span":"BackToTopButton_span__a_jPD","text":"BackToTopButton_text__r_3ME"};